"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Tracked = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function trackClickHOC(Component) {
  var event = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'UNLABELED';
  var additional = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var composed =
  /*#__PURE__*/
  function (_React$Component) {
    _inherits(Composed, _React$Component);

    function Composed() {
      _classCallCheck(this, Composed);

      return _possibleConstructorReturn(this, _getPrototypeOf(Composed).apply(this, arguments));
    }

    _createClass(Composed, [{
      key: "handleClick",
      value: function handleClick() {
        var initialState = window.__INITIAL_STATE__ || {};
        var _initialState$userPre = initialState.userPrefs,
            userPrefs = _initialState$userPre === void 0 ? {} : _initialState$userPre;

        if (typeof caLogger !== 'undefined') {
          caLogger.track(event, _objectSpread({}, additional, {
            userUUID: userPrefs.ConcurId,
            companyUUID: userPrefs.companyUUID
          }));
        }
      }
    }, {
      key: "render",
      value: function render() {
        return _react.default.createElement("span", {
          style: this.props.style,
          onClick: this.handleClick
        }, Component);
      }
    }]);

    return Composed;
  }(_react.default.Component);

  composed.propTypes = {
    style: _propTypes.default.object
  };
  return composed;
}

var Tracked =
/*#__PURE__*/
function (_React$Component2) {
  _inherits(Tracked, _React$Component2);

  function Tracked() {
    _classCallCheck(this, Tracked);

    return _possibleConstructorReturn(this, _getPrototypeOf(Tracked).apply(this, arguments));
  }

  _createClass(Tracked, [{
    key: "handleClick",
    value: function handleClick() {
      var initialState = window.__INITIAL_STATE__ || {};
      var _this$props = this.props,
          event = _this$props.event,
          additional = _this$props.additional;
      var _initialState$userPre2 = initialState.userPrefs,
          userPrefs = _initialState$userPre2 === void 0 ? {} : _initialState$userPre2;

      if (typeof caLogger !== 'undefined') {
        caLogger.track(event, _objectSpread({}, additional, {
          userUUID: userPrefs.ConcurId,
          companyUUID: userPrefs.companyUUID
        }));
      }
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("span", {
        style: this.props.style,
        onClick: this.handleClick.bind(this)
      }, this.props.children);
    }
  }]);

  return Tracked;
}(_react.default.Component);

exports.Tracked = Tracked;
Tracked.propTypes = {
  style: _propTypes.default.object,
  event: _propTypes.default.string,
  additional: _propTypes.default.object,
  children: _propTypes.default.node
};
var _default = trackClickHOC;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/HOCs/trackClick.js
// module id = 11
// module chunks = 0